import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import useCurrentUser from '~/hooks/useCurrentUser'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { selectCurrentCertificate, setShouldShowCertificateModalActionCreator } from '../slice/curriculum.slice'

import AnimatedImageSwitcher from './Animation'
import Certificate from './Certificate'

const CurriculumCertificateClaimModal = (): React.ReactElement => {
  const { t } = useTranslation('curriculum')

  const [shouldShowAnimation, setShouldShowAnimation] = useState(true)
  const [shouldShowCertificateModal, setShouldShowCertificateModal] = useState(false)

  const dispatch = useAppDispatch()
  const user = useCurrentUser()
  const userName = user?.nickname || user?.fullName || user?.firstName || t('mathLearner')

  const certificate = useAppSelector(selectCurrentCertificate)

  return (
    <div>
      {shouldShowAnimation && (
        <AnimatedImageSwitcher
          data={certificate}
          onClose={() => {
            dispatch(setShouldShowCertificateModalActionCreator(false))
          }}
          showCertificateModal={() => {
            setShouldShowCertificateModal(true)
            setShouldShowAnimation(false)
          }}
        />
      )}
      {shouldShowCertificateModal && certificate && (
        <Certificate
          data={certificate}
          isOpen={shouldShowCertificateModal}
          name={userName}
          onClose={() => {
            setShouldShowCertificateModal(false)
            dispatch(setShouldShowCertificateModalActionCreator(false))
          }}
        />
      )}
    </div>
  )
}

export default CurriculumCertificateClaimModal
